export enum LogTypeEnum {
  Critical = 'critical',
  Warning = 'warning',
  Info = 'info',
  Debug = 'debug',
  Error = 'error',
}

export interface LogModel {
  id: string;
  time: number;
  level: LogTypeEnum;
  message: string;
  success?: boolean;
}
